import Tasks from 'APP/Tasks';
import { removeMessageReaction as removeMessageReactionModel } from 'APP/model/message/messageModel';
import { IUpdateMessageReaction } from 'APP/model/message/messageModel.types';

export const removeMessageReaction = async (data: IUpdateMessageReaction): Promise<void> => {
  try {
    const message = await removeMessageReactionModel(data);
    Tasks.messaging.updateOldOrFakeMessages({
      messages: [message],
      groupId: message.groupId,
    });
  } catch (error) {
    // do nothing
  }
};
